module.exports = __webpack_public_path__ + "img/chevrons-left.ecac39b0.svg";